import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface PartnerResource {
  data: {
    partnerId: number;
    balance: number;
    totalClicks: number;
    totalAmountSpent: number;
    defaultCityPrice: number;
    name: string;
    sendReports: boolean;
    reportEmail: string;
    immediateRedirect: boolean;
  };
  cityPrices: Array<{
    geonameId: number;
    price: number;
    isEnabled: boolean;
    city: string;
    countryCode: string;
  }>;
}

export default (makeCall: MakeCall) => (partnerId: number) =>
  makeCall<PartnerResource>('GET', `/api/v2/partner/${partnerId}`);
